import { createTheme } from '@mui/material/styles';

const dosTheme = createTheme({
  palette: {
    mode: 'dark', // Dark mode is essential for the terminal look
    background: {
      default: '#000000', // Black background
      paper: '#000000', // Use the same black for "paper" elements
    },
    text: {
      primary: '#00FF00', // Green text for primary content
      secondary: '#00AA00', // Slightly dimmer green for secondary content
    },
  },
  typography: {
    fontFamily: '"VT323", monospace', // Use VT323 font globally
    fontSize: 14, // Adjust font size as needed
    h1: {
      fontFamily: '"VT323", monospace', // Ensure h1 uses VT323 font
      fontSize: '3rem', // Adjust size for h1
      fontWeight: 400, // Keep the font weight consistent with the terminal look
    },
  },
  components: {
    MuiTextField: {
      styleOverrides: {
        root: {
          '& .MuiInputBase-input': {
            color: '#00FF00',
            backgroundColor: '#001100', // Dark green input background
          },
          '& .MuiOutlinedInput-notchedOutline': {
            borderColor: '#00FF00',
          },
          '&:hover .MuiOutlinedInput-notchedOutline': {
            borderColor: '#00AA00',
          },
        },
      },
    },
    MuiButton: {
      styleOverrides: {
        root: {
          color: '#000000', // Black text
          backgroundColor: '#00FF00', // Green background
          borderColor: '#00FF00', // Green border
          '&:hover': {
            backgroundColor: '#003300', // Dark green hover effect
          },
        },
      },
    },
    MuiSlider: {
      styleOverrides: {
        root: {
          color: '#00FF00', // Green color for the slider
        },
        thumb: {
          backgroundColor: '#00FF00', // Green color for the thumb
          '&:hover': {
            backgroundColor: '#00AA00',
          },
        },
        track: {
          backgroundColor: '#00FF00', // Green color for the track
        },
        rail: {
          backgroundColor: '#00FF00', // Dark green for the rail
        },
      },
    },
  },
});

export default dosTheme;